import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ISoftUpdate } from 'app/models/softUpdate';
import { IUnits } from 'app/models/units';
import { ToastService } from '../../../../services/toast.service';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { BeerDetailPage } from 'app/pages/inventory/beer/beer-detail/beer-detail.page';
import { IBeverage } from 'app/models/beverage';
import { UnitsHelper } from '../../../../services/units.helper';
import { SelectBeverageComponent } from 'app/components/select-beverage/select-beverage.component';
import { IBar } from 'app/models/bar';
import { IKeg } from 'app/models/keg';
import { Dictionary } from '@ngrx/entity';
import { ITap } from 'app/models/tap';
import { ILocation } from 'app/models/location';
import * as dateHelper from 'app/helpers/date.helpers';
import { CommonModule, DecimalPipe } from '@angular/common';
import { TapChooserPage } from '../tap-chooser/tap-chooser.page';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule],
  providers: [DecimalPipe]
})
export class FormComponent implements OnChanges {



  @Input() item!: IKeg;
  @Input() bar!: IBar;
  @Input() allBeverages!: Dictionary<IBeverage>;
  @Input() allTaps!: ITap[];
  @Input() allLocations!: ILocation[];
  @Input() units!: IUnits;
  @Input() uid!: string;


  @Output() softUpdateKeg = new EventEmitter<ISoftUpdate<IKeg>>();
  @Output() softUpdateTap = new EventEmitter<ISoftUpdate<ITap>>();

  containers = [
    {
      name: 'PubKeg',
      icon: 'assets/icons/beercontaners/pub.png'
    },
    {
      name: 'CornyKeg',
      icon: 'assets/icons/beercontaners/corny.png'
    },
    {
      name: 'CornyKeg12',
      icon: 'assets/icons/beercontaners/corny12.png'
    },
    {
      name: 'CornyKeg09',
      icon: 'assets/icons/beercontaners/corny09.png'
    },
    // {
    //   name: 'Glass',
    //   icon: 'assets/icons/beercontaners/glass.svg'
    // },
  ];

  form = this.fb.group({
    name: ['', { validators: [Validators.required] }],
    description: [''],
    size: ['', { validators: [Validators.required] }],
    nettoWeight: ['', { validators: [Validators.required] }],
    amount: ['', { validators: [Validators.required] }],
    notificationMessage: [''],
    location: [''],
  });

  cleanDate!: string | null;
  tapDate!: string | null;
  bestBeforeDate!: string | null;
  notificationDate!: string | null;
  conditionDate!: string | null;
  beverage!: IBeverage | undefined;

  oldSize!: number;
  oldAmount!: number;

  constructor(
    private fb: FormBuilder,
    private unitsHelper: UnitsHelper,
    private decimalPipe: DecimalPipe,
    // private dateHelper: DateHelper,
    private toastService: ToastService,
    private modalController: ModalController,
  ) {

  }


  ngOnChanges(changes: SimpleChanges) {

    if (this.allBeverages && this.item.beverageId) {
      this.beverage = this.allBeverages[this.item.beverageId];
    }

    if (changes['item']?.currentValue) {

      //#region Date convertions

      if (this.item.tapDate) {
        this.tapDate = dateHelper.getISOString(this.item.tapDate as any);
      }
      if (this.item.bestBeforeDate) {
        this.bestBeforeDate = dateHelper.getISOString(this.item.bestBeforeDate as any);
      }
      if (this.item.notificationDate) {
        this.notificationDate = dateHelper.getISOString(this.item.notificationDate as any);
      }
      if (this.item.cleanDate) {
        this.cleanDate = dateHelper.getISOString(this.item.cleanDate as any);
      }
      if (this.item.conditionDate) {
        this.conditionDate = dateHelper.getISOString(this.item.conditionDate as any);
      }

      if (!!this.item.beverageId) {
        this.beverage = this.allBeverages[this.item.beverageId];
      } else {
        this.beverage = undefined;
      }

      //#endregion Date convertions

      //#region Notifidation
      if (this.item.notificationDate) {
        this.form.controls.notificationMessage.addValidators(Validators.required);
        console.info('required');

      } else {
        this.form.controls.notificationMessage.removeValidators(Validators.required);
        console.info('not required');
      }
      //#endregion Notifidation

      this.patchFormFromItem(this.item);
    }
  }



  updateName() {
    if (this.form.controls.name.invalid) {
      this.toastService.error("Name is required");
      return;
    }

    if (this.form.controls.name.value === this.item.name) return;
    if (this.item?.id) {
      const update: Partial<IKeg> = {
        name: this.form.controls.name.value ?? ''
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }

  }

  updateDescription() {

    if (this.form.controls.description.value === this.item.description) return;
    if (this.item?.id) {
      const update: Partial<IKeg> = {
        description: this.form.controls.description.value ?? ''
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }

  updateNotificationMessage() {
    if (this.form.controls.notificationMessage.invalid) {
      this.toastService.error("Notification message is required");
      return;
    }

    if (this.form.controls.notificationMessage.value === this.item.notificationMessage) return;
    if (this.item?.id) {
      const update: Partial<IKeg> = {
        notificationMessage: this.form.controls.notificationMessage.value ?? ''
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }

  }


  setContainer(name: string) {
    if (!name) {
      return;
    }
    if (this.item.id) {
      const update: Partial<IKeg> = {
        container: name
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }

  updateNettoWeight() {
    if (this.form.controls.nettoWeight.invalid) {
      this.toastService.error("Netto weight is required");
      return;
    }
    const nettoWeight = +(this.form.controls.nettoWeight.value ?? '0');

    const value = this.unitsHelper.toUnit(nettoWeight, this.units.kegWeight, 'kg', -1);

    if (this.item.id) {
      const update: Partial<IKeg> = {
        nettoWeight: value
      };

      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }

  updateSize() {
    if (this.form.controls.size.invalid) {
      this.toastService.error("Size is required");
      return;
    }
    const size = +(this.form.controls.size.value ?? '0');
    const value = this.unitsHelper.toUnit(size, this.units.kegs, 'l', -1);
    if (this.item.id) {
      const update: Partial<IKeg> = {
        size: value
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }

  updateAmount() {
    if (this.form.controls.amount.invalid) {
      this.toastService.error("Amount is reqoured");
      return;
    }
    const amount = +(this.form.controls.amount.value ?? '0');
    const value = this.unitsHelper.toUnit(amount, this.units.kegs, 'l', -1);

    if (this.item.id) {
      const update: Partial<IKeg> = {
        amount: value
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }

  async deleteBeverage() {
    if (this.item.id) {
      const update: Partial<IKeg> = {
        beverageId: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }



  updateLocation(event: any) {
    const locationId = event.detail.value;
    if (this.item.id) {
      const update: Partial<IKeg> = {
        locationId: locationId
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }


  //#region Modals




  async openBeer(id: string) {

    const modal = await this.modalController.create({
      component: BeerDetailPage,
      componentProps: {
        isModal: true,
        itemId: id
      }
    });
    return await modal.present();
  }

  public async openBeverageModal() {
    const modal = await this.modalController.create({
      component: SelectBeverageComponent,
    });

    modal.onDidDismiss().then(async (data) => {
      if (!data.data?.item) {
        return;
      }
      const beverageData = data.data.item as IBeverage;
      if (!beverageData || !this.item.id) {
        return;
      }
      const update: Partial<IKeg> = {
        beverageId: beverageData.id,
        cleanDate: null
      };

      this.cleanDate = null;

      this.softUpdateCurrentKeg(this.item.id, update);
    });

    return await modal.present();
  }

  //#endregion Modals



  //region Date methods





  //#region CleanDate
  setDefaultCleanDate() {
    const date = new Date();
    this.cleanDate = dateHelper.toISOString();
    if (this.item.id) {
      const update: Partial<IKeg> = {
        cleanDate: date,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  setCleanDate(event: any) {
    const value = event.detail.value;
    if (value) {
      if (this.item.id) {
        const update: Partial<IKeg> = {
          cleanDate: new Date(value),
        };
        this.softUpdateCurrentKeg(this.item.id, update);
      }
    }
  }
  deleteCleanDate() {
    this.cleanDate = '';
    if (this.item.id) {
      const update: Partial<IKeg> = {
        cleanDate: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  //#region Clean  Date

  //#region Tap Date
  setDefaultKegTapDate() {
    const date = new Date();
    this.tapDate = dateHelper.toISOString();
    if (this.item.id) {
      const update: Partial<IKeg> = {
        tapDate: date,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  setKegTapDate(event: any) {
    const value = event.detail.value;
    if (value) {
      if (this.item.id) {
        const update: Partial<IKeg> = {
          tapDate: new Date(value),
        };
        this.softUpdateCurrentKeg(this.item.id, update);
      }
    }
  }
  deleteKegTapDate() {
    this.tapDate = '';
    if (this.item.id) {
      const update: Partial<IKeg> = {
        tapDate: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  //#region Clean  Date

  //#region Best Before Date
  setDefaultKegBestBeforeDate() {
    const date = new Date();
    this.bestBeforeDate = dateHelper.toISOString();
    if (this.item.id) {
      const update: Partial<IKeg> = {
        bestBeforeDate: date,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  setKegBestBeforeDate(event: any) {
    const value = event.detail.value;
    if (value) {
      if (this.item.id) {
        const update: Partial<IKeg> = {
          bestBeforeDate: new Date(value),
        };
        this.softUpdateCurrentKeg(this.item.id, update);
      }
    }
  }
  deleteKegBestBeforeDate() {
    this.bestBeforeDate = '';
    if (this.item.id) {
      const update: Partial<IKeg> = {
        bestBeforeDate: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  //#region Clean  Date



  //#region Notification Date
  setDefaultKegNotificationDate() {
    const date = new Date();
    this.notificationDate = dateHelper.toISOString();
    if (this.item.id) {
      if (!this.item.notificationMessage) {
        this.form.controls.notificationMessage.markAsTouched();
      }
      const update: Partial<IKeg> = {
        notificationDate: date,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  setKegNotificationDate(event: any) {
    const value = event.detail.value;
    if (value) {
      if (this.item.id) {
        if (!this.item.notificationMessage) {
          this.form.controls.notificationMessage.markAsTouched();
        }
        const update: Partial<IKeg> = {
          notificationDate: new Date(value),
        };
        this.softUpdateCurrentKeg(this.item.id, update);
      }
    }
  }
  deleteKegNotificationDate() {
    this.notificationDate = '';
    if (this.item.id) {
      const update: Partial<IKeg> = {
        notificationDate: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  //#region Notification Date

  //#region Condition End Date
  setDefaultConditionDate() {
    const date = new Date();
    this.conditionDate = dateHelper.toISOString();
    if (this.item.id) {
      const update: Partial<IKeg> = {
        conditionDate: date,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }

  }
  setConditionDate(event: any) {
    const value = event.detail.value;
    if (value && this.item.id) {
      const update: Partial<IKeg> = {
        conditionDate: new Date(value),
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  deleteConditionDate() {
    this.conditionDate = '';
    if (this.item.id) {
      const update: Partial<IKeg> = {
        conditionDate: null,
      };
      this.softUpdateCurrentKeg(this.item.id, update);
    }
  }
  //#region Best Before Date
  //endregion Date methods



  // #region FORM to ITEM
  private patchFormFromItem(item: IKeg) {
    const nettWeightFormatted = this.decimalPipe.transform(item.nettoWeight, '1.3-3');
    this.form.patchValue({
      name: item.name,
      description: item.description ?? '',
      size: item.size.toString(),
      amount: item.amount.toString(),
      location: item.locationId,
      nettoWeight: nettWeightFormatted,
      notificationMessage: item.notificationMessage ?? '',
    });
  }
  //#endregion FORM to ITEM


  private softUpdateCurrentKeg(kegId: string, item: Partial<IKeg>) {
    const update: ISoftUpdate<IKeg> = {
      id: kegId,
      data: item,
      uid: this.uid
    };
    this.softUpdateKeg.emit(update);

  }

  // #region Tap assignment (mirror of the keg field on the tap detail page)
  // The tap↔keg link lives on the tap (ITap.kegId), so "which tap is this keg
  // on" is derived by scanning taps for kegId === this keg's id.
  get currentTap(): ITap | undefined {
    return this.item?.id ? this.allTaps?.find(t => t.kegId === this.item.id) : undefined;
  }

  async openTapChooser() {
    if (!this.item?.id) return;
    const modal = await this.modalController.create({
      component: TapChooserPage,
      componentProps: { keg: this.item, uid: this.uid },
    });
    // The chooser writes the assignment (and any move) directly via the store,
    // so the live tap selector updates currentTap — nothing to do on dismiss.
    return await modal.present();
  }

  removeTapFromKeg(tap: ITap) {
    if (!tap.id) return;
    this.softUpdateTap.emit({ id: tap.id, data: { kegId: '' }, uid: this.uid });
  }
  // #endregion Tap assignment


}
